import React, { useMemo } from 'react';
import { useTranslation } from '../../i18n';
import { ProductFilter } from './ProductFilters';

const OWNER_FILTER_ID = 'owner';

export interface OwnerFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const OwnerFilter: React.FC<OwnerFilterProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const summary = useMemo(() => {
    const trimmed = value.trim();
    if (trimmed) {
      return t('products.owner_summary_value', { owner: trimmed });
    }
    return t('products.owner_summary_any');
  }, [value, t]);

  return (
    <ProductFilter id={OWNER_FILTER_ID} summary={summary}>
      <div className="owner-filter">
        <label className="owner-filter__field">
          <span className="owner-filter__label">{t('products.owner_filter')}</span>
          <input
            type="text"
            value={value}
            placeholder={t('products.owner_filter')}
            onChange={e => onChange(e.target.value)}
          />
        </label>
      </div>
    </ProductFilter>
  );
};
